export default __webpack_public_path__ + "static/media/Background_00231.e1176bbc.png";